<template>
  <div class="child">
    <div>
      <div class="main">
        <div class="list">
          <div>文档中心</div>
          <ul>
            <li v-for="item in tabs" :key="item.index">
              <router-link active-class="active" :to="{name:item.path}">{{item.type}}</router-link>
            </li>
          </ul>
        </div>
        <div class="con">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataCenter',
  data () {
    return {
      tabs: [
        {
          type: '项目整体构想',
          path: 'wholeIdea'
        }, {
          type: '项目中期报告',
          path: 'report'
        }, {
          type: '项目主要发现',
          path: 'found'
        }, {
          type: '政策建议与对策',
          path: 'advice'
        }
      ]
    }
  }
}
</script>
<style scoped src="../assets/style/child.css">
  /* @import '../assets/style/child.css'; */
</style>


// WEBPACK FOOTER //
// src/components/DocumentCenter.vue